import { Link } from '@remix-run/react';
import ArrowIcon from '~/assets/icons/ArrowIcon';
import { PLACEHOLDER_IMAGE_URL } from '~/constants';
import { CollectionsQuery } from '~/generated/graphql';
export function CollectionCard({
  collection,
}: {
  collection: CollectionsQuery['collections']['items'][number];
}) {
  return (
    <div
      key={collection.id}
      className="max-w-[300px] relative rounded-lg overflow-hidden border border-gray-200 "
    >
      <div className="flex items-center bg-white  px-3 py-4">
        <Link to={'/collections/' + collection.slug} prefetch="intent">
          <div className="w-[100px] h-[100px] object-center object-contain">
            <img
              src={
                collection.featuredAsset?.preview
                  ? collection.featuredAsset?.preview + '?w=100&h=100'
                  : PLACEHOLDER_IMAGE_URL
              }
              alt={collection.name}
              className="rounded-xl"
            />
          </div>
        </Link>
        <div className="ml-4 ">
          <Link to={'/collections/' + collection.slug} prefetch="intent">
            <p className="text-xl font-semibold text-gray-900">
              {collection.name}
            </p>
          </Link>
          <Link to={'/collections/' + collection.slug} prefetch="intent">
            <button className="mt-2 px-4 py-2 gap-2 bg-secondary text-white rounded-md text-sm font-semibold hover:bg-pink-700 flex items-center justify-center">
              Shop Now <ArrowIcon />
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
